// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin: 1.5rem 0 0 1.5rem;
}

.asset-capture-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 1.5rem;
  margin: 0 auto;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  cursor: pointer;
}

.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}

.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: 6px;
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.page-header, .details-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.25rem;
  margin-bottom: 1.25rem;
}

.page-heading h1, .details-header h2 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.35rem, 2vw, 1.7rem);
  font-weight: 650;
  line-height: 1.3;
}

.page-heading p, .details-subtitle {
  margin: 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
}

.btn-primary, .btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  min-height: 2.6rem;
  padding: 0.65rem 1rem;
  border-radius: var(--ca-radius-md, 8px);
  font-size: 0.9rem;
  font-weight: 600;
  line-height: 1.25;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.btn-primary {
  border: 1px solid var(--ca-primary, #0e2e80);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.btn-primary:hover:not(:disabled) {
  border-color: var(--ca-primary-dark, #0d2863);
  background: var(--ca-primary-dark, #0d2863);
  color: #fff;
}

.btn-secondary {
  border: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-surface, #fff);
  color: var(--ca-primary, #0e2e80);
}

.btn-secondary:hover:not(:disabled) {
  border-color: var(--ca-primary, #0e2e80);
  background: var(--ca-surface-active, #eef3ff);
}

.btn-primary:focus-visible, .btn-secondary:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 2px;
}

.btn-primary:disabled, .btn-secondary:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.add-source-button {
  flex: 0 0 auto;
}

.empty-state {
  display: grid;
  min-height: min(70vh, 42rem);
  place-items: center;
  padding: 2rem 1rem;
}

.empty-state-content {
  width: min(100%, 42rem);
  text-align: center;
}

.empty-state-icon {
  display: grid;
  width: 4.25rem;
  height: 4.25rem;
  place-items: center;
  margin: 0 auto 1.25rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 1.25rem;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 2rem;
}

.empty-state h1 {
  margin: 0 0 0.6rem;
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  font-weight: 650;
}

.empty-state p {
  margin: 0 auto 1.25rem;
  max-width: 34rem;
  color: var(--ca-text-secondary, #4b5870);
  line-height: 1.6;
}

.empty-state-action {
  margin: 0 auto;
}

.asset-list-card, .asset-details-card {
  min-width: 0;
  padding: 1.25rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-lg, 14px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 8px rgba(17, 35, 71, 0.05));
}

.asset-details-card {
  margin-top: 1.25rem;
}

.search-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(12rem, 16rem);
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.search-field, .filter-field {
  min-width: 0;
  position: relative;
}

.search-field {
  display: flex;
  align-items: center;
}

.search-control {
  min-height: 2.7rem;
  border-color: var(--ca-border, #dfe4ec);
  color: var(--ca-text-primary, #172033);
}

.search-control:focus {
  border-color: var(--ca-primary, #0e2e80);
  box-shadow: 0 0 0 0.2rem rgba(40, 80, 173, 0.13);
}

.search-field .search-control {
  padding-right: 3rem;
}

.search-submit {
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;
  display: grid;
  width: 2.2rem;
  height: 2.2rem;
  place-items: center;
  border: 0;
  border-radius: var(--ca-radius-sm, 6px);
  background: var(--ca-primary, #0e2e80);
  color: #fff;
}

.search-submit:hover {
  background: var(--ca-primary-dark, #0d2863);
}

.table-region {
  width: 100%;
  min-width: 0;
  overflow-x: auto;
}

.list-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 1rem;
}

.state-panel, .no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  min-height: 12rem;
  padding: 2rem 1rem;
  text-align: center;
  color: var(--ca-text-secondary, #4b5870);
}

.state-panel h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.3rem;
}

.state-panel p, .no-results p {
  margin: 0;
}

.error-state > i, .no-results > i {
  color: var(--ca-danger, #b42318);
  font-size: 1.6rem;
}

.loading-state > p {
  margin-top: 0.2rem;
}

.loading-spinner {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ca-border, #dfe4ec);
  border-top-color: var(--ca-primary, #0e2e80);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.loading-spinner-sm {
  width: 1rem;
  height: 1rem;
  border-width: 2px;
}

.inline-loading {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.75rem 0;
  color: var(--ca-text-secondary, #4b5870);
}

.inline-error {
  margin: 0.75rem 0;
  padding: 0.75rem 0.9rem;
  border: 1px solid var(--ca-danger, #b42318);
  border-radius: 8px;
  background: var(--ca-danger-bg, #fff2f0);
  color: var(--ca-danger, #b42318);
}

.inline-success {
  margin: 0.75rem 0;
  padding: 0.75rem 0.9rem;
  border: 1px solid var(--ca-success, #17803d);
  border-radius: 8px;
  background: var(--ca-success-bg, #edfff3);
  color: var(--ca-success, #176b35);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.source-options-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.25rem;
}

.tool-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  padding: 1.5rem;
  border: 1px solid var(--ca-border, #dfe4ec);
  border-radius: var(--ca-radius-lg, 14px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 8px rgba(17, 35, 71, 0.05));
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.tool-card:hover {
  transform: translateY(-3px);
  border-color: var(--ca-primary, #0e2e80);
  box-shadow: var(--ca-shadow-md, 0 8px 22px rgba(17, 35, 71, 0.1));
}

.card-icon {
  display: grid;
  width: 3rem;
  height: 3rem;
  place-items: center;
  margin-bottom: 1rem;
  border-radius: 12px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 1.5rem;
}

.tool-title {
  margin: 0 0 0.65rem;
  color: var(--ca-text-primary, #172033);
  font-size: 1.1rem;
  font-weight: 650;
  line-height: 1.4;
}

.tool-description {
  flex-grow: 1;
  margin: 0 0 1.25rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.6;
}

.btn-open {
  align-self: flex-start;
}

.options-page-header {
  align-items: center;
}

.eyebrow {
  margin: 0 0 0.25rem;
  color: var(--ca-primary, #0e2e80);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.details-header {
  align-items: center;
  margin-bottom: 0.5rem;
}

.details-header h2 {
  font-size: 1.25rem;
}

.data-assets-table-wrap {
  width: 100%;
  overflow-x: auto;
  margin-top: 0.75rem;
}

.data-assets-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.data-assets-table th {
  padding: 0.8rem 0.75rem;
  border-bottom: 1px solid var(--ca-border, #dfe4ec);
  background: var(--ca-bg-secondary, #f7f9fc);
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.75rem;
  font-weight: 700;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.035em;
  white-space: nowrap;
}

.data-assets-table td {
  max-width: 17rem;
  padding: 0.85rem 0.75rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
  color: var(--ca-text-primary, #172033);
  vertical-align: top;
}

.data-assets-table tbody tr:hover {
  background: var(--ca-bg, #f8faff);
}

.data-assets-table td strong, .data-assets-table td small {
  display: block;
}

.data-assets-table td small {
  margin-top: 0.2rem;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.75rem;
}

.endpoint-cell {
  min-width: 10rem;
  overflow-wrap: anywhere;
}

.status-pill {
  display: inline-block;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
  font-size: 0.75rem;
  font-weight: 650;
}

/* Center the back button beneath the source option cards */
.back-to-sources-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.75rem auto 0;
  padding-bottom: 0.5rem;
}

@media (max-width: 900px) {
  .source-options-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .search-toolbar {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 600px) {
  .breadcrumb {
    margin-left: 1rem;
  }
  .asset-capture-page {
    padding: 1rem;
  }
  .page-header, .details-header {
    align-items: stretch;
    flex-direction: column;
  }
  .add-source-button {
    align-self: flex-start;
  }
  .source-options-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .asset-list-card, .asset-details-card {
    padding: 0.9rem;
  }
  .list-footer {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/shared-workflows/data-asset-capture/data-asset-capture.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,oCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,eAAA;AACF;;AAEA;EAAyB,sCAAA;EAAwC,0BAAA;AAGjE;;AAFA;EAAiC,0CAAA;EAA2C,mBAAA;EAAqB,kBAAA;AAQjG;;AAPA;EAAqB,kBAAA;AAWrB;;AAVA;EAAwB,oCAAA;AAcxB;;AAbA;EAAsB,wCAAA;EAA0C,gBAAA;AAkBhE;;AAjBA;EACE,kBAAA;AAoBF;;AAjBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;AAoBF;;AAjBA;EACE,mBAAA;EACA,sCAAA;EACA,sCAAA;EACA,gBAAA;EACA,gBAAA;AAoBF;;AAjBA;EACE,SAAA;EACA,wCAAA;EACA,iBAAA;AAoBF;;AAjBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uFAAA;AAoBF;;AAjBA;EAAe,4CAAA;EAA8C,sCAAA;EAAwC,WAAA;AAuBrG;;AAtBA;EAAoC,6CAAA;EAA+C,2CAAA;EAA6C,WAAA;AA4BhI;;AA3BA;EAAiB,2CAAA;EAA6C,mCAAA;EAAqC,iCAAA;AAiCnG;;AAhCA;EAAsC,wCAAA;EAA0C,6CAAA;AAqChF;;AApCA;EAA2D,0CAAA;EAA2C,mBAAA;AAyCtG;;AAxCA;EAAiD,mBAAA;EAAqB,YAAA;AA6CtE;;AA5CA;EAAqB,cAAA;AAgDrB;;AA9CA;EACE,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,kBAAA;AAiDF;;AA/CA;EAAuB,uBAAA;EAAyB,kBAAA;AAoDhD;;AAnDA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,iDAAA;EACA,sBAAA;EACA,6CAAA;EACA,iCAAA;EACA,eAAA;AAsDF;;AApDA;EAAkB,kBAAA;EAAmB,sCAAA;EAAwC,gBAAA;AA0D7E;;AAzDA;EAAiB,sBAAA;EAAwB,gBAAA;EAAkB,wCAAA;EAA0C,gBAAA;AAgErG;;AA/DA;EAAsB,cAAA;AAmEtB;;AAjEA;EACE,YAAA;EACA,gBAAA;EACA,2CAAA;EACA,wCAAA;EACA,mCAAA;EACA,iEAAA;AAoEF;;AAlEA;EAAsB,mBAAA;AAsEtB;;AArEA;EAAkB,aAAA;EAAe,0DAAA;EAA4D,YAAA;EAAa,mBAAA;AA4E1G;;AA3EA;EAA+B,YAAA;EAAc,kBAAA;AAgF7C;;AA/EA;EAAgB,aAAA;EAAe,mBAAA;AAoF/B;;AAnFA;EAAkB,kBAAA;EAAoB,uCAAA;EAAyC,sCAAA;AAyF/E;;AAxFA;EAAwB,wCAAA;EAA0C,gDAAA;AA6FlE;;AA5FA;EAAgC,mBAAA;AAgGhC;;AA/FA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;EACA,uCAAA;EACA,sCAAA;EACA,WAAA;AAkGF;;AAhGA;EAAuB,2CAAA;AAoGvB;;AAnGA;EAAgB,WAAA;EAAa,YAAA;EAAc,gBAAA;AAyG3C;;AAxGA;EAAe,aAAA;EAAe,yBAAA;EAA2B,iBAAA;AA8GzD;;AA5GA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;AA+GF;;AA7GA;EAAkB,SAAA;EAAW,sCAAA;EAAwC,iBAAA;AAmHrE;;AAlHA;EAAgC,SAAA;AAsHhC;;AArHA;EAAoC,gCAAA;EAAkC,iBAAA;AA0HtE;;AAzHA;EAAqB,kBAAA;AA6HrB;;AA5HA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,4CAAA;EACA,kBAAA;EACA,oCAAA;AA+HF;;AA7HA;EAAsB,WAAA;EAAa,YAAA;EAAc,iBAAA;AAmIjD;;AAlIA;EAAkB,aAAA;EAAe,mBAAA;EAAqB,WAAA;EAAY,kBAAA;EAAmB,wCAAA;AA0IrF;;AAzIA;EAAgB,iBAAA;EAAkB,uBAAA;EAAuB,2CAAA;EAA6C,kBAAA;EAAoB,wCAAA;EAA0C,gCAAA;AAkJpK;;AAjJA;EAAkB,iBAAA;EAAkB,uBAAA;EAAuB,4CAAA;EAA8C,kBAAA;EAAoB,yCAAA;EAA2C,iCAAA;AA0JxK;;AAzJA;EAAkB;IAAK,yBAAA;EA8JrB;AACF;AA7JA;EAAuB,aAAA;EAAe,gDAAA;EAAkD,YAAA;AAkKxF;;AAjKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,2CAAA;EACA,wCAAA;EACA,mCAAA;EACA,iEAAA;EACA,gFAAA;AAoKF;;AAlKA;EAAmB,2BAAA;EAA6B,wCAAA;EAA0C,iEAAA;AAwK1F;;AAvKA;EAAa,aAAA;EAAe,WAAA;EAAa,YAAA;EAAc,mBAAA;EAAqB,mBAAA;EAAqB,mBAAA;EAAqB,6CAAA;EAA+C,iCAAA;EAAmC,iBAAA;AAmLxM;;AAlLA;EAAc,mBAAA;EAAoB,sCAAA;EAAwC,iBAAA;EAAmB,gBAAA;EAAkB,gBAAA;AA0L/G;;AAzLA;EAAoB,YAAA;EAAc,mBAAA;EAAqB,wCAAA;EAA0C,iBAAA;EAAkB,gBAAA;AAiMnH;;AAhMA;EAAY,sBAAA;AAoMZ;;AAnMA;EAAuB,mBAAA;AAuMvB;;AArMA;EAAW,mBAAA;EAAoB,iCAAA;EAAmC,kBAAA;EAAmB,gBAAA;EAAkB,sBAAA;EAAuB,yBAAA;AA8M9H;;AA7MA;EAAkB,mBAAA;EAAqB,qBAAA;AAkNvC;;AAjNA;EAAqB,kBAAA;AAqNrB;;AApNA;EAA0B,WAAA;EAAa,gBAAA;EAAkB,mBAAA;AA0NzD;;AAzNA;EAAqB,WAAA;EAAa,yBAAA;EAA2B,mBAAA;AA+N7D;;AA9NA;EAAwB,uBAAA;EAAuB,kDAAA;EAAoD,2CAAA;EAA6C,wCAAA;EAA0C,kBAAA;EAAmB,gBAAA;EAAkB,gBAAA;EAAkB,yBAAA;EAA2B,uBAAA;EAAwB,mBAAA;AA2OpS;;AA1OA;EAAwB,gBAAA;EAAkB,wBAAA;EAAwB,wDAAA;EAA0D,sCAAA;EAAwC,mBAAA;AAkPpK;;AAjPA;EAAoC,iCAAA;AAqPpC;;AApPA;EAA4D,cAAA;AAwP5D;;AAvPA;EAA8B,kBAAA;EAAmB,oCAAA;EAAsC,kBAAA;AA6PvF;;AA5PA;EAAiB,gBAAA;EAAkB,uBAAA;AAiQnC;;AAhQA;EAAe,qBAAA;EAAuB,uBAAA;EAAuB,oBAAA;EAAsB,6CAAA;EAA+C,iCAAA;EAAmC,kBAAA;EAAmB,gBAAA;AA0QxL;;AAzQA,2DAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;AA4QF;;AA1QA;EACE;IAAuB,gDAAA;EA8QvB;EA7QA;IAAkB,qCAAA;EAgRlB;AACF;AA9QA;EACE;IAAc,iBAAA;EAiRd;EAhRA;IAAsB,aAAA;EAmRtB;EAlRA;IAAgC,oBAAA;IAAsB,sBAAA;EAsRtD;EArRA;IAAqB,sBAAA;EAwRrB;EAvRA;IAAuB,qCAAA;EA0RvB;EAzRA;IAAwC,eAAA;EA4RxC;EA3RA;IAAe,uBAAA;EA8Rf;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n  color: var(--ca-text-primary, #172033);\n}\n\n.breadcrumb {\n  margin: 1.5rem 0 0 1.5rem;\n}\n\n.asset-capture-page {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  padding: 1.5rem;\n  margin: 0 auto;\n}\n\n.breadcrumb-nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin: 0 0 1.25rem;\n  color: var(--ca-text-muted, #8c96a8);\n  font-size: 0.875rem;\n}\n\n.breadcrumb-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--ca-primary, #0e2e80);\n  font: inherit;\n  cursor: pointer;\n}\n\n.breadcrumb-link:hover { color: var(--ca-primary-dark, #0d2863); text-decoration: underline; }\n.breadcrumb-link:focus-visible { outline: 3px solid rgba(40, 80, 173, .25); outline-offset: 3px; border-radius: 6px; }\n.breadcrumb-link i { font-size: 1.25rem; }\n.breadcrumb-separator { color: var(--ca-text-muted, #8c96a8); }\n.breadcrumb-current { color: var(--ca-text-secondary, #4b5870); font-weight: 500; }\n.breadcrumb-current i {\n  font-size: 1.25rem;\n}\n\n.page-header, .details-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.page-heading h1, .details-header h2 {\n  margin: 0 0 .35rem;\n  color: var(--ca-text-primary, #172033);\n  font-size: clamp(1.35rem, 2vw, 1.7rem);\n  font-weight: 650;\n  line-height: 1.3;\n}\n\n.page-heading p, .details-subtitle {\n  margin: 0;\n  color: var(--ca-text-secondary, #4b5870);\n  font-size: .9rem;\n}\n\n.btn-primary, .btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: .5rem;\n  min-height: 2.6rem;\n  padding: .65rem 1rem;\n  border-radius: var(--ca-radius-md, 8px);\n  font-size: .9rem;\n  font-weight: 600;\n  line-height: 1.25;\n  white-space: nowrap;\n  transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;\n}\n\n.btn-primary { border: 1px solid var(--ca-primary, #0e2e80); background: var(--ca-primary, #0e2e80); color: #fff; }\n.btn-primary:hover:not(:disabled) { border-color: var(--ca-primary-dark, #0d2863); background: var(--ca-primary-dark, #0d2863); color: #fff; }\n.btn-secondary { border: 1px solid var(--ca-border, #dfe4ec); background: var(--ca-surface, #fff); color: var(--ca-primary, #0e2e80); }\n.btn-secondary:hover:not(:disabled) { border-color: var(--ca-primary, #0e2e80); background: var(--ca-surface-active, #eef3ff); }\n.btn-primary:focus-visible, .btn-secondary:focus-visible { outline: 3px solid rgba(40, 80, 173, .25); outline-offset: 2px; }\n.btn-primary:disabled, .btn-secondary:disabled { cursor: not-allowed; opacity: .6; }\n.add-source-button { flex: 0 0 auto; }\n\n.empty-state {\n  display: grid;\n  min-height: min(70vh, 42rem);\n  place-items: center;\n  padding: 2rem 1rem;\n}\n.empty-state-content { width: min(100%, 42rem); text-align: center; }\n.empty-state-icon {\n  display: grid;\n  width: 4.25rem;\n  height: 4.25rem;\n  place-items: center;\n  margin: 0 auto 1.25rem;\n  border: 1px solid var(--ca-border-light, #e9edf3);\n  border-radius: 1.25rem;\n  background: var(--ca-surface-active, #eef3ff);\n  color: var(--ca-primary, #0e2e80);\n  font-size: 2rem;\n}\n.empty-state h1 { margin: 0 0 .6rem; font-size: clamp(1.35rem, 2vw, 1.8rem); font-weight: 650; }\n.empty-state p { margin: 0 auto 1.25rem; max-width: 34rem; color: var(--ca-text-secondary, #4b5870); line-height: 1.6; }\n.empty-state-action { margin: 0 auto; }\n\n.asset-list-card, .asset-details-card {\n  min-width: 0;\n  padding: 1.25rem;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: var(--ca-radius-lg, 14px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 8px rgba(17, 35, 71, .05));\n}\n.asset-details-card { margin-top: 1.25rem; }\n.search-toolbar { display: grid; grid-template-columns: minmax(0, 1fr) minmax(12rem, 16rem); gap: .75rem; margin-bottom: 1rem; }\n.search-field, .filter-field { min-width: 0; position: relative; }\n.search-field { display: flex; align-items: center; }\n.search-control { min-height: 2.7rem; border-color: var(--ca-border, #dfe4ec); color: var(--ca-text-primary, #172033); }\n.search-control:focus { border-color: var(--ca-primary, #0e2e80); box-shadow: 0 0 0 .2rem rgba(40, 80, 173, .13); }\n.search-field .search-control { padding-right: 3rem; }\n.search-submit {\n  position: absolute;\n  top: .25rem;\n  right: .25rem;\n  display: grid;\n  width: 2.2rem;\n  height: 2.2rem;\n  place-items: center;\n  border: 0;\n  border-radius: var(--ca-radius-sm, 6px);\n  background: var(--ca-primary, #0e2e80);\n  color: #fff;\n}\n.search-submit:hover { background: var(--ca-primary-dark, #0d2863); }\n.table-region { width: 100%; min-width: 0; overflow-x: auto; }\n.list-footer { display: flex; justify-content: flex-end; padding-top: 1rem; }\n\n.state-panel, .no-results {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: .65rem;\n  min-height: 12rem;\n  padding: 2rem 1rem;\n  text-align: center;\n  color: var(--ca-text-secondary, #4b5870);\n}\n.state-panel h1 { margin: 0; color: var(--ca-text-primary, #172033); font-size: 1.3rem; }\n.state-panel p, .no-results p { margin: 0; }\n.error-state > i, .no-results > i { color: var(--ca-danger, #b42318); font-size: 1.6rem; }\n.loading-state > p { margin-top: .2rem; }\n.loading-spinner {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ca-border, #dfe4ec);\n  border-top-color: var(--ca-primary, #0e2e80);\n  border-radius: 50%;\n  animation: spin .8s linear infinite;\n}\n.loading-spinner-sm { width: 1rem; height: 1rem; border-width: 2px; }\n.inline-loading { display: flex; align-items: center; gap: .6rem; padding: .75rem 0; color: var(--ca-text-secondary, #4b5870); }\n.inline-error { margin: .75rem 0; padding: .75rem .9rem; border: 1px solid var(--ca-danger, #b42318); border-radius: 8px; background: var(--ca-danger-bg, #fff2f0); color: var(--ca-danger, #b42318); }\n.inline-success { margin: .75rem 0; padding: .75rem .9rem; border: 1px solid var(--ca-success, #17803d); border-radius: 8px; background: var(--ca-success-bg, #edfff3); color: var(--ca-success, #176b35); }\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.source-options-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 1.25rem; }\n.tool-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  height: 100%;\n  padding: 1.5rem;\n  border: 1px solid var(--ca-border, #dfe4ec);\n  border-radius: var(--ca-radius-lg, 14px);\n  background: var(--ca-surface, #fff);\n  box-shadow: var(--ca-shadow-sm, 0 2px 8px rgba(17, 35, 71, .05));\n  transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease;\n}\n.tool-card:hover { transform: translateY(-3px); border-color: var(--ca-primary, #0e2e80); box-shadow: var(--ca-shadow-md, 0 8px 22px rgba(17, 35, 71, .1)); }\n.card-icon { display: grid; width: 3rem; height: 3rem; place-items: center; margin-bottom: 1rem; border-radius: 12px; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: 1.5rem; }\n.tool-title { margin: 0 0 .65rem; color: var(--ca-text-primary, #172033); font-size: 1.1rem; font-weight: 650; line-height: 1.4; }\n.tool-description { flex-grow: 1; margin: 0 0 1.25rem; color: var(--ca-text-secondary, #4b5870); font-size: .9rem; line-height: 1.6; }\n.btn-open { align-self: flex-start; }\n.options-page-header { align-items: center; }\n\n.eyebrow { margin: 0 0 .25rem; color: var(--ca-primary, #0e2e80); font-size: .75rem; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; }\n.details-header { align-items: center; margin-bottom: .5rem; }\n.details-header h2 { font-size: 1.25rem; }\n.data-assets-table-wrap { width: 100%; overflow-x: auto; margin-top: .75rem; }\n.data-assets-table { width: 100%; border-collapse: collapse; font-size: .875rem; }\n.data-assets-table th { padding: .8rem .75rem; border-bottom: 1px solid var(--ca-border, #dfe4ec); background: var(--ca-bg-secondary, #f7f9fc); color: var(--ca-text-secondary, #4b5870); font-size: .75rem; font-weight: 700; text-align: left; text-transform: uppercase; letter-spacing: .035em; white-space: nowrap; }\n.data-assets-table td { max-width: 17rem; padding: .85rem .75rem; border-bottom: 1px solid var(--ca-border-light, #e9edf3); color: var(--ca-text-primary, #172033); vertical-align: top; }\n.data-assets-table tbody tr:hover { background: var(--ca-bg, #f8faff); }\n.data-assets-table td strong, .data-assets-table td small { display: block; }\n.data-assets-table td small { margin-top: .2rem; color: var(--ca-text-muted, #8c96a8); font-size: .75rem; }\n.endpoint-cell { min-width: 10rem; overflow-wrap: anywhere; }\n.status-pill { display: inline-block; padding: .2rem .55rem; border-radius: 999px; background: var(--ca-surface-active, #eef3ff); color: var(--ca-primary, #0e2e80); font-size: .75rem; font-weight: 650; }\n/* Center the back button beneath the source option cards */\n.back-to-sources-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin: 1.75rem auto 0;\n  padding-bottom: 0.5rem;\n}\n@media (max-width: 900px) {\n  .source-options-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .search-toolbar { grid-template-columns: minmax(0, 1fr); }\n}\n\n@media (max-width: 600px) {\n  .breadcrumb { margin-left: 1rem; }\n  .asset-capture-page { padding: 1rem; }\n  .page-header, .details-header { align-items: stretch; flex-direction: column; }\n  .add-source-button { align-self: flex-start; }\n  .source-options-grid { grid-template-columns: minmax(0, 1fr); }\n  .asset-list-card, .asset-details-card { padding: .9rem; }\n  .list-footer { justify-content: center; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
